import { BillingConfirmComponent } from '../components/dashboard/loggedin-content/billing/billing-confirm/billing-confirm.component';
import { MapfreCardComponent } from '../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreInfoDivsComponent } from '../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { HeaderComponent } from '../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreInfoDivsComponent, MapfreCardComponent, BillingConfirmComponent],
  selector: 'app-ach-billing-confirm',
  templateUrl: './ach-billing-confirm.component.html',
})
export class AchBillingConfirmComponent implements OnInit {
  policyId: string;
  isIEBrowser: boolean;
  constructor(private activatedRoute: ActivatedRoute) {}
  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });

    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.isIEBrowser = true;
    }
  }
}
